import { Colors } from "themes/color-palette";

export const Semantic = {
  Text: {
    primary: Colors.black,
    secondary: Colors.gray["600"],
    informational: Colors.blue["500"],
    positive: Colors.green["600"],
    negative: Colors.red["600"],
    white: Colors.white
  },
  Background: {
    primary: Colors.white,
    secondary: Colors.gray["50"],
    black: Colors.black,
    tertiary: Colors.gray["100"],
    informational: Colors.blue["500"],
    positive: Colors.green["600"],
    warning: Colors.yellow["500"],
    negative: Colors.red["600"],
    informationalSubtle: Colors.blue["50"],
    positiveSubtle: Colors.green["50"],
    warningSubtle: Colors.yellow["50"],
    negativeSubtle: Colors.red["50"]
  },
  Border: {
    primary: Colors.gray["100"],
    secondary: Colors.gray["200"],
    negative: Colors.red["600"]
  },
  DataVisualization: {
    positive: Colors.green["500"],
    negative: Colors.red["500"]
  }
};

export type SemanticBackgroundColor = keyof typeof Semantic.Background;
